import Axios from "axios";

export const SelectReglementFournisseur = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/REGFRs?&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({
        type: "Reglement_Fournisseur_SELECT",
        payload: response.data,
      });
    });
  };
};
